/**
 * App status constants
 *
 * IMPORTANT: These values must match the backend definitions in:
 * backend/coding_agent/context.py
 *
 * Any changes to status values must be synchronized between frontend and backend.
 */

// App status constants - MUST match backend/coding_agent/context.py
export const APP_STATUS_CONFIRMING_DEMAND = "confirming_demand";
export const APP_STATUS_PREPARING_PRD = "preparing_prd";
export const APP_STATUS_GENERATING = "generating";
export const APP_STATUS_UPDATING = "updating";
export const APP_STATUS_TESTING = "testing";
export const APP_STATUS_DEPLOYED = "deployed";
export const APP_STATUS_ERROR = "error";

export const VALID_APP_STATUSES = [
  APP_STATUS_CONFIRMING_DEMAND,
  APP_STATUS_PREPARING_PRD,
  APP_STATUS_GENERATING,
  APP_STATUS_UPDATING,
  APP_STATUS_TESTING,
  APP_STATUS_DEPLOYED,
  APP_STATUS_ERROR
];

/**
 * Map backend status to user-friendly display messages
 */
export const STATUS_DISPLAY_MAP = {
  [APP_STATUS_CONFIRMING_DEMAND]: {
    text: 'Understanding your requirements...',
    status: 'processing'
  },
  [APP_STATUS_PREPARING_PRD]: {
    text: 'Preparing product requirements...',
    status: 'processing'
  },
  [APP_STATUS_GENERATING]: {
    text: 'Generating your app...',
    status: 'processing'
  },
  [APP_STATUS_UPDATING]: {
    text: 'Updating your app...',
    status: 'processing'
  },
  [APP_STATUS_TESTING]: {
    text: 'Testing the app...',
    status: 'processing'
  },
  [APP_STATUS_DEPLOYED]: {
    text: 'App is ready!',
    status: 'completed'
  },
  [APP_STATUS_ERROR]: {
    text: 'Generation failed',
    status: 'error'
  }
};

/**
 * Check if status represents a completed state
 */
export const isCompletedStatus = (status) => {
  return status === APP_STATUS_DEPLOYED;
};

/**
 * Check if status represents a failed state
 */
export const isFailedStatus = (status) => {
  return status === APP_STATUS_ERROR;
};

/**
 * Check if status represents an in-progress state
 */
export const isProcessingStatus = (status) => {
  return [
    APP_STATUS_CONFIRMING_DEMAND,
    APP_STATUS_PREPARING_PRD,
    APP_STATUS_GENERATING,
    APP_STATUS_UPDATING,
    APP_STATUS_TESTING
  ].includes(status);
};
